import { useEffect } from "react";
import { Reveal, WindReveal, BranchDivider, BranchAccent } from "@/components/Cinematic";

const TIMELINE = [
  { y: "2018", t: "seedesign takes root — brand identity and packaging for emerging D2C labels." },
  { y: "2020", t: "Led creative direction for kidswear and organic collections." },
  { y: "2022", t: "Partnered with heritage crafts — Bhujodi weaving and indigo dyeing." },
  { y: "Today", t: "A small studio helping premium brands scale across shelves, screens and marketplaces." },
];
const PRINCIPLES = [
  "Strategy before decoration.",
  "Craft is a competitive advantage.",
  "Every design should earn its place.",
  "Sustainability is specific, not slogans.",
  "The work should outlast the trend.",
];

export default function About() {
  useEffect(() => { document.title = "About — seedesign"; }, []);
  return (
    <div className="pt-28 pb-24 relative overflow-hidden">
      <BranchAccent position="top-right" />
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 relative z-10">
        <p className="text-sm uppercase tracking-[0.2em] text-[#66371B] mb-4">About</p>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tight text-[#3F3F2C] max-w-4xl leading-[0.95]">
          <WindReveal text="We build brands the way nature builds — patiently, and to last." />
        </h1>
        <div className="mt-10 grid md:grid-cols-2 gap-10 max-w-4xl">
          <p className="text-lg text-[#3F3F2C] leading-relaxed">
            seedesign is a brand and creative studio based in New Delhi, founded by Pravidhi Jain — a NIFT Delhi
            graduate whose work is inspired by everything in nature. Since 2018 we&apos;ve helped founders turn premium
            ideas into brands that convert — across D2C, fashion, home décor and lifestyle.
          </p>
          <p className="text-lg text-[#3F3F2C] leading-relaxed">
            Our work sits at the meeting point of craft and commerce: rooted in research and heritage, yet built to scale
            across shelves, screens and marketplaces. We believe design that remembers where it came from lasts longer than a trend.
          </p>
        </div>
      </div>

      <BranchDivider flowers />

      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 mt-6 relative z-10">
        <h2 className="font-serif text-4xl text-[#3F3F2C] mb-12">How the studio grew</h2>
        <div className="border-l border-[#81754B]/40 pl-8 space-y-10">
          {TIMELINE.map((e, i) => (
            <Reveal key={i} delay={i * 0.05} className="relative">
              <span className="absolute -left-[41px] top-2 h-3 w-3 rounded-full bg-[#66371B]" />
              <p className="font-serif text-2xl text-[#66371B]">{e.y}</p>
              <p className="text-lg text-[#3F3F2C] mt-1 max-w-2xl">{e.t}</p>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 mt-24 relative z-10">
        <h2 className="font-serif text-4xl text-[#3F3F2C] mb-12">Principles we design by</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {PRINCIPLES.map((p, i) => (
            <Reveal key={i} delay={(i % 3) * 0.06} className="rounded-sm border border-[#E3D8C1] bg-[#F7F1E1]/70 p-8">
              <span className="font-serif text-3xl text-[#81754B]">{String(i + 1).padStart(2, "0")}</span>
              <p className="signature text-2xl text-[#3F3F2C] mt-3">{p}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
